import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "data-table-shell"
};
const _hoisted_2 = {
  key: 0,
  class: "p-8 text-center text-slate-500"
};
const _hoisted_3 = {
  key: 1,
  class: "data-table-scroll"
};
const _hoisted_4 = {
  class: "data-table"
};
const _hoisted_5 = {
  class: "data-table-body"
};
const _hoisted_6 = {
  class: "flex items-center justify-between px-6 py-4 border-b border-slate-200"
};
const _hoisted_7 = {
  class: "text-lg font-semibold text-slate-900"
};
const _hoisted_8 = {
  class: "p-6 space-y-4"
};
import { ref, reactive, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import { getDeptTree, createDept, updateDept, deleteDept } from '@/api/dept';
import ListPageShell from '@/components/ListPageShell.vue';
import UserSelector from '@/components/UserSelector/index.vue';
import DeptTreeItem from './DeptTreeItem.vue';
import AppModal from '@/components/AppModal.vue';

// 加载状态

export default {
  __name: 'DeptManagement',
  setup(__props) {
    const loading = ref(false);

    // 部门树
    const deptTree = ref([]);

    // 获取部门列表
    async function fetchDepts() {
      loading.value = true;
      try {
        const data = await getDeptTree();
        // 确保 children 是数组
        const normalizeChildren = items => {
          if (!items || !Array.isArray(items)) return [];
          return items.map(item => ({
            ...item,
            children: item.children && item.children.length > 0 ? normalizeChildren(item.children) : []
          }));
        };
        deptTree.value = normalizeChildren(data);
        buildAllDepts();
      } catch (error) {
        console.error('获取部门列表错误:', error);
        ElMessage.error(error.message || '获取部门列表失败');
      } finally {
        loading.value = false;
      }
    }
    onMounted(() => {
      fetchDepts();
    });

    // 获取所有部门（扁平化）
    const allDepts = ref([]);
    function buildAllDepts() {
      allDepts.value = [];
      function traverse(items) {
        for (const item of items) {
          allDepts.value.push({
            id: item.id,
            name: item.name
          });
          if (item.children && item.children.length > 0) {
            traverse(item.children);
          }
        }
      }
      traverse(deptTree.value);
    }
    buildAllDepts();

    // 展开/折叠状态
    const expandedIds = ref([]);
    const allExpanded = ref(false);

    // 模态框状态
    const showModal = ref(false);
    const showDeleteModal = ref(false);
    const isEdit = ref(false);
    const pendingDelete = ref(null);

    // 表单数据
    const form = reactive({
      id: '',
      name: '',
      code: '',
      sort: 0,
      managerUserId: null,
      phone: '',
      status: true,
      parentId: null,
      parentName: ''
    });

    // 切换单个树节点
    function toggleTree(deptId) {
      const index = expandedIds.value.indexOf(deptId);
      if (index > -1) {
        expandedIds.value.splice(index, 1);
      } else {
        expandedIds.value.push(deptId);
      }
    }

    // 展开/折叠所有
    function toggleAllTrees() {
      allExpanded.value = !allExpanded.value;
      if (allExpanded.value) {
        expandedIds.value = deptTree.value.filter(d => d.children && d.children.length > 0).map(d => d.id);
      } else {
        expandedIds.value = [];
      }
    }

    // 打开新增模态框
    function openAddModal(dept) {
      isEdit.value = false;
      form.id = '';
      form.parentId = dept ? dept.id : null;
      form.parentName = dept ? dept.name : '';
      form.name = '';
      form.code = '';
      form.sort = 0;
      form.managerUserId = null;
      form.phone = '';
      form.status = true;
      showModal.value = true;
    }

    // 打开编辑模态框
    function openEditModal(dept) {
      isEdit.value = true;
      form.id = dept.id;
      form.name = dept.name;
      form.code = dept.code || '';
      form.sort = dept.sort || 0;
      form.managerUserId = dept.managerUserId || null;
      form.phone = dept.phone || '';
      form.status = dept.status !== undefined ? dept.status : true;
      form.parentId = dept.parentId || null;
      form.parentName = dept.parentId === null || dept.parentId === 0 ? '' : getParentName(dept.id);
      showModal.value = true;
    }

    // 获取父级部门名称
    function getParentName(deptId) {
      for (const dept of deptTree.value) {
        if (dept.children) {
          const child = dept.children.find(c => c.id === deptId);
          if (child) return dept.name;
        }
      }
      return '';
    }

    // 关闭模态框
    function closeModal() {
      showModal.value = false;
    }

    // 保存部门
    async function saveDept() {
      if (!form.name.trim()) {
        ElMessage.warning('请输入部门名称');
        return;
      }
      if (!form.code.trim()) {
        ElMessage.warning('请输入部门编码');
        return;
      }
      try {
        if (isEdit.value) {
          await updateDept(form.id, {
            name: form.name,
            code: form.code,
            sort: form.sort,
            managerUserId: form.managerUserId,
            phone: form.phone,
            status: form.status,
            parentId: form.parentId
          });
          ElMessage.success('修改成功');
        } else {
          await createDept({
            name: form.name,
            code: form.code,
            sort: form.sort,
            managerUserId: form.managerUserId,
            phone: form.phone,
            status: form.status,
            parentId: form.parentId || null
          });
          ElMessage.success('新增成功');
        }
        await fetchDepts();
        closeModal();
      } catch (error) {
        ElMessage.error(error.message || '操作失败');
      }
    }

    // 删除部门
    function handleDelete(dept) {
      pendingDelete.value = dept;
      showDeleteModal.value = true;
    }

    // 确认删除
    async function confirmDelete() {
      if (pendingDelete.value) {
        try {
          await deleteDept(pendingDelete.value.id);
          ElMessage.success('删除成功');
          await fetchDepts();
        } catch (error) {
          ElMessage.error(error.message || '删除失败');
        }
      }
      closeDeleteModal();
    }

    // 关闭删除确认弹窗
    function closeDeleteModal() {
      showDeleteModal.value = false;
      pendingDelete.value = null;
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      return _openBlock(), _createBlock(ListPageShell, null, {
        header: _withCtx(() => [_createElementVNode("div", {
          class: "list-page-panel is-header-minimal"
        }, [_createElementVNode("div", {
          class: "list-page-heading"
        }, [_cache[8] || (_cache[8] = _createElementVNode("div", {
          class: "list-page-heading-main"
        }, [_createElementVNode("h1", {
          class: "list-page-title"
        }, "部门管理"), _createElementVNode("p", {
          class: "list-page-description"
        }, "维护部门树结构、负责人、排序及状态信息。")], -1)), _createElementVNode("div", {
          class: "flex items-center gap-2"
        }, [_createElementVNode("button", {
          class: "btn-secondary inline-flex items-center gap-1",
          onClick: toggleAllTrees
        }, [...(_cache[7] || (_cache[7] = [_createElementVNode("svg", {
          class: "w-4 h-4",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("path", {
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "2",
          d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
        })], -1), _createTextVNode(" 展开/折叠 ", -1)]))])])])])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[9] || (_cache[9] = [_createElementVNode("svg", {
          class: "animate-spin w-6 h-6 mx-auto mb-2 text-primary-600",
          fill: "none",
          viewBox: "0 0 24 24"
        }, [_createElementVNode("circle", {
          class: "opacity-25",
          cx: "12",
          cy: "12",
          r: "10",
          stroke: "currentColor",
          "stroke-width": "4"
        }), _createElementVNode("path", {
          class: "opacity-75",
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        })], -1), _createTextVNode(" 加载中... ", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("table", _hoisted_4, [_cache[10] || (_cache[10] = _createElementVNode("thead", {
          class: "data-table-head"
        }, [_createElementVNode("tr", null, [_createElementVNode("th", {
          class: "data-table-th text-left"
        }, "部门名称"), _createElementVNode("th", {
          class: "data-table-th text-left w-32"
        }, "部门编码"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "排序"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "负责人"), _createElementVNode("th", {
          class: "data-table-th text-left w-24"
        }, "状态"), _createElementVNode("th", {
          class: "data-table-th text-left data-table-sticky-right data-table-sticky-head data-table-sticky-action"
        }, "操作")])], -1)), _createElementVNode("tbody", _hoisted_5, [_createVNode(DeptTreeItem, {
          items: deptTree.value,
          "expanded-ids": expandedIds.value,
          onToggle: toggleTree,
          onAdd: openAddModal,
          onEdit: openEditModal,
          onDelete: handleDelete
        }, null, 8, ["items", "expanded-ids"])])])]))]), _createVNode(AppModal, {
          visible: showDeleteModal.value,
          size: "sm",
          "panel-class": "mx-4",
          onClose: closeDeleteModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "p-6 text-center"
          }, [_cache[11] || (_cache[11] = _createElementVNode("div", {
            class: "w-12 h-12 mx-auto mb-4 text-red-500"
          }, [_createElementVNode("svg", {
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          })])], -1)), _cache[12] || (_cache[12] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900 mb-2"
          }, "确定要删除吗？", -1)), _cache[13] || (_cache[13] = _createElementVNode("p", {
            class: "text-sm text-slate-500 mb-6"
          }, "删除后无法恢复，请确认是否删除。", -1)), _createElementVNode("div", {
            class: "flex items-center justify-center gap-3"
          }, [_createElementVNode("button", {
            onClick: closeDeleteModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: confirmDelete,
            class: "btn-danger-secondary"
          }, "确定删除")])])]),
          _: 1
        }, 8, ["visible"]), _createVNode(AppModal, {
          visible: showModal.value,
          size: "lg",
          "panel-class": "mx-4",
          onClose: closeModal
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("h3", _hoisted_7, _toDisplayString(isEdit.value ? '修改部门' : '新增部门'), 1), _createElementVNode("button", {
            onClick: closeModal,
            class: "p-1.5 text-slate-400 hover:text-slate-600 hover:bg-slate-100 rounded-lg transition-colors"
          }, [...(_cache[14] || (_cache[14] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", null, [_cache[15] || (_cache[15] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "上级部门", -1)), _createVNode(_component_el_select, {
            modelValue: form.parentId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.parentId = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "无（顶级部门）",
              value: ""
            }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDepts.value, dept => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: dept.id,
                label: dept.name,
                value: dept.id
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[16] || (_cache[16] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, [_createTextVNode("部门名称 "), _createElementVNode("span", {
            class: "text-red-500"
          }, "*")], -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.name = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入部门名称"
          }, null, 512), [[_vModelText, form.name]])]), _createElementVNode("div", null, [_cache[17] || (_cache[17] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "部门编码", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => form.code = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入部门编码"
          }, null, 512), [[_vModelText, form.code]])]), _createElementVNode("div", null, [_cache[18] || (_cache[18] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "部门主管", -1)), _createVNode(UserSelector, {
            modelValue: form.managerUserId,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => form.managerUserId = $event),
            placeholder: "请选择部门主管"
          }, null, 8, ["modelValue"])]), _createElementVNode("div", null, [_cache[19] || (_cache[19] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "联系电话", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => form.phone = $event),
            type: "text",
            class: "form-input w-full",
            placeholder: "请输入联系电话"
          }, null, 512), [[_vModelText, form.phone]])]), _createElementVNode("div", null, [_cache[20] || (_cache[20] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "排序号", -1)), _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => form.sort = $event),
            type: "number",
            class: "form-input w-full",
            placeholder: "数字越大越靠后"
          }, null, 512), [[_vModelText, form.sort, void 0, {
            number: true
          }]])]), _createElementVNode("div", null, [_cache[21] || (_cache[21] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-1"
          }, "状态", -1)), _createVNode(_component_el_select, {
            modelValue: form.status,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => form.status = $event),
            class: "form-select w-full"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "正常",
              value: true
            }), _createVNode(_component_el_option, {
              label: "停用",
              value: false
            })]),
            _: 1
          }, 8, ["modelValue"])])]), _createElementVNode("div", {
            class: "flex items-center justify-end gap-3 px-6 py-4 border-t border-slate-200 bg-slate-50 rounded-b-xl"
          }, [_createElementVNode("button", {
            onClick: closeModal,
            class: "btn-secondary"
          }, "取消"), _createElementVNode("button", {
            onClick: saveDept,
            class: "btn-primary"
          }, "确定")])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      });
    };
  }
};